<template>
	<div>
		<el-form-item label="技师头衔名称">
			<el-select v-model="form.waiter.labelId" placeholder="请选择" @change="handleSelectChange">
				<el-option v-for="item in form.all_label" :key="item.labelId" :label="item.name"
					:value="item.labelId">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="技师头衔图片">
			<img v-if="selectedLabel" :src="selectedLabel.fileAddress"
				style="max-width: 100px; max-height: 100px;">
		</el-form-item>
		<el-form-item label="技师头像：">
			<el-row>
				<div class="draggable-list">
					<div class="item img-select" v-if="form.waiter.avatarurl==''"
						@click="openProductUpload('image', 'image')">
						<i class="el-icon-plus"></i>
					</div>
					<div v-if="form.waiter.avatarurl!=''" class="item" @click="openProductUpload('image', 'image')">
						<img :src="form.waiter.avatarurl" width="100" height="100" />
					</div>
				</div>
			</el-row>
		</el-form-item>
		<el-form-item label="性别" prop="waiter.gender">
			<el-radio-group v-model="form.waiter.gender">
				<el-radio :label="1">男性</el-radio>
				<el-radio :label="0">女性</el-radio>
			</el-radio-group>
		</el-form-item>
		<el-form-item label="生日">
			<el-date-picker class="max-w460" style="width:100%" v-model="form.waiter.birthday" type="date"
				placeholder="选择日期">
			</el-date-picker>
		</el-form-item>
		<el-form-item label="年龄">
			<el-input class="max-w460" v-model="form.waiter.age"></el-input>
		</el-form-item>
		<el-form-item label="身高">
			<el-input class="max-w460" placeholder="请输入身高" v-model="form.waiter.height">
				<template slot="append">cm</template>
			</el-input>
		</el-form-item>
		<el-form-item label="手机号">
			<el-input v-model="form.waiter.mobile" class="max-w460"></el-input>
		</el-form-item>
		<el-form-item label="个人介绍">
			<el-input class="max-w460" type="textarea" v-model="form.waiter.introduce" placeholder="请输入个人介绍"></el-input>
		</el-form-item>
		<!-- <el-form-item label="标签">
			<el-tag :key="tag" v-for="tag in form.waiter.tag" closable :disable-transitions="false"
				@close="handleClose(tag)">
				{{tag}}
			</el-tag>
			<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
				@keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
			</el-input>
			<el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>

		</el-form-item> -->

		<Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
			上传图片</Upload>
	</div>
</template>
<script>
	import Upload from "@/components/file/Upload";
	import draggable from "vuedraggable";
	export default {
		components: {
			Upload,
			draggable
		},

		data() {
			return {
				isProductUpload: false,
				config: {},
				file_name: "image",
				// form.waiter.tag: ["标签一", "标签二", "标签三"],
				inputVisible: false,
				inputValue: "",
				birthday: "",
				selectedLabel: null // 保存选择的label对象
			};
		},
		mounted() {
			if (this.form.waiter.tag == null) {
				this.form.waiter.tag = [];
			}
			this.handleSelectChange(); // 调用handleSelectChange方法来显示对应的图片
		},
		inject: ["form"],
		methods: {
			abcImg() {
				this.openProductUpload('image', 'image')
			},
			handleSelectChange() {
				// 根据选择的label_id找到对应的label对象
				this.selectedLabel = this.form.all_label.find(
					item => item.labelId == this.form.waiter.labelId
				);
				console.log(this.selectedLabe,909090)
			},
			/*打开上传图片*/
			openProductUpload: function(fileType, file_name) {
				this.file_name = file_name;
				if (fileType == "image") {
					this.config = {
						total: 1,
						fileType: "image"
					};
				} else {
					this.config = {
						total: 1,
						fileType: "video"
					};
				}
				this.isProductUpload = true;
			},

			/*上传商品图片*/
			returnProductImgsFunc(e) {
				console.log("=========", e);
				if (e != null) {
					if (this.file_name == "image") {
						// this.form.waiter.avatarUrl_id = e[0].fileId;
						this.form.waiter.avatarUrl = e[0].filePath;
					}
				}
				this.isProductUpload = false;
			},

			handleClose(tag) {
				this.form.waiter.tag.splice(this.form.waiter.tag.indexOf(tag), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.form.waiter.tag.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = "";
			}
		}
	};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/technician/technicianlist/part/introduce.vue